export enum ImageTier {
  Thumb = "thumb",
  Small = "small",
  Full = "full",
}

type VariantSource = {
  pictures?: string[] | null;
  smalls?: string[] | null;
  thumbnails?: string[] | null;
};

// `small` falls back to the picture, not the feed thumbnail: feed-imported
// listings have no `smalls` and their thumbnail is often ~200px, which would be
// softer on a card than the merely-oversized picture.
export const pickImage = (
  source: VariantSource | null | undefined,
  tier: ImageTier,
  index = 0,
): string | undefined => {
  if (!source) return undefined;
  const picture = source.pictures?.[index];
  const small = source.smalls?.[index];
  const thumb = source.thumbnails?.[index];

  if (tier === ImageTier.Full) return picture ?? small ?? thumb;
  if (tier === ImageTier.Small) return small ?? picture ?? thumb;
  return thumb ?? small ?? picture;
};

export const pickPropertyImage = (
  source:
    | {
        imageUrls?: string[] | null;
        smalls?: string[] | null;
        thumbnails?: string[] | null;
      }
    | null
    | undefined,
  tier: ImageTier,
  index = 0,
): string | undefined =>
  pickImage(
    source
      ? {
          pictures: source.imageUrls,
          smalls: source.smalls,
          thumbnails: source.thumbnails,
        }
      : undefined,
    tier,
    index,
  );

export const pickImageList = (
  source: VariantSource | null | undefined,
  tier: ImageTier,
): string[] => {
  const length = source?.pictures?.length ?? 0;
  return Array.from({ length }, (_, i) => pickImage(source, tier, i)).filter(
    (url): url is string => Boolean(url),
  );
};
